'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/LockSimple.js";
var p = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var t = (o, e, m) => e in o ? p(o, e, { enumerable: true, configurable: true, writable: true, value: m }) : o[e] = m, a = (o, e) => {
  for (var m in e || (e = {}))
    s.call(e, m) && t(o, m, e[m]);
  if (r)
    for (var m of r(e))
      l.call(e, m) && t(o, m, e[m]);
  return o;
}, i = (o, e) => c(o, f(e));
const I = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, i(a({ ref: e }, o), { weights: t$1 })));
I.displayName = "LockSimple";
export {
  I as LockSimple
};
